<template>
  <div class="dept-role-teacher-select">
    <el-input
      :value="displayLabel"
      :placeholder="placeholder"
      readonly
      style="width: 100%;"
      @focus="showPopover = true"
    >
      <span slot="suffix" class="dept-role-teacher-suffix">
        <i
          v-if="displayLabel"
          class="el-input__icon el-icon-circle-close"
          @click.stop="clear"
        ></i>
        <i
          class="el-input__icon el-icon-arrow-down"
          @click.stop="showPopover = !showPopover"
        ></i>
      </span>
    </el-input>
    <el-popover
      ref="popover"
      v-model="showPopover"
      placement="bottom-start"
      width="300"
      trigger="manual"
      popper-class="dept-role-cascader-popover"
    >
      <el-cascader
        v-model="cascaderPath"
        :options="cascaderOptions"
        :props="cascaderProps"
        :placeholder="placeholder"
        filterable
        style="width: 100%;"
        @change="onCascaderChange"
      ></el-cascader>
    </el-popover>
  </div>
</template>

<script>
import url from '@/plugins/urlHelper.js';

const DEPT_GROUPS = {
  留学: [
    { label: '营销', roleIds: '4,10' },
    { label: '顾问', roleIds: '3,9' },
    { label: '文案', roleIds: '2,8' }
  ],
  日语: [
    { label: '营销', roleIds: '13,18' },
    { label: '顾问', roleIds: '11,16' },
    { label: '教务', roleIds: '23' }
  ],
  鸣野: [
    { label: '营销', roleIds: '17,20' },
    { label: '顾问', roleIds: '15,19' }
  ]
};

const ROLE_IDS_TO_LABEL = {
  '2,8': '文案', '3,9': '顾问', '4,10': '营销',
  '11,16': '顾问', '13,18': '营销', '23': '教务',
  '15,19': '顾问', '17,20': '营销'
};

export default {
  name: 'DeptRoleTeacherSelect',
  props: {
    dept: { type: String, required: true },
    value: { type: [Number, String], default: null },
    placeholder: { type: String, default: '请选择部门 → 角色 → 老师' }
  },
  data() {
    return {
      displayLabel: '',   // 根据 userID 查接口得到的展示文案：部门 / 角色 / 姓名
      showPopover: false,
      cascaderPath: [],
      cascaderProps: {
        lazy: true,
        lazyLoad: this.lazyLoadNodes,
        value: 'value',
        label: 'label',
        leaf: 'leaf'
      }
    };
  },
  computed: {
    cascaderOptions() {
      return ['留学', '日语', '鸣野'].map((d) => ({
        value: d,
        label: d,
        leaf: false
      }));
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val == null || val === '') {
          this.displayLabel = '';
          return;
        }
        this.loadDisplayLabel(Number(val));
      },
      immediate: true
    },
    showPopover(val) {
      if (!val) return;
      this.cascaderPath = [];
      if (this.value) {
        const self = this;
        $.get(url.getStu('GetUserRole'), { userID: this.value }, (data) => {
          if (!data || !data.dept || !data.roleIds) return;
          self.cascaderPath = [data.dept, data.roleIds, Number(self.value)];
        });
      }
    }
  },
  methods: {
    loadDisplayLabel(userID) {
      if (!userID) {
        this.displayLabel = '';
        return;
      }
      const self = this;
      $.get(url.getStu('GetUserRole'), { userID }, (data) => {
        if (!data) {
          self.displayLabel = '';
          return;
        }
        const dept = data.dept || '';
        const roleIds = data.roleIds || '';
        const realName = data.realName || '';
        const roleLabel = ROLE_IDS_TO_LABEL[roleIds] || '';
        if (dept && realName) {
          self.displayLabel = roleLabel ? `${dept} / ${roleLabel} / ${realName}` : `${dept} / ${realName}`;
        } else {
          self.displayLabel = realName || '';
        }
      }).fail(() => {
        self.displayLabel = '';
      });
    },
    lazyLoadNodes(node, resolve) {
      const { value } = node;
      if (value && DEPT_GROUPS[value]) {
        const list = DEPT_GROUPS[value].map((g) => ({
          value: g.roleIds,
          label: g.label,
          leaf: false
        }));
        resolve(list);
        return;
      }
      // 第二级：value 为 roleIds（可能含逗号如 '11,16'，或单角色如 '23'）
      if (value && (String(value).indexOf(',') !== -1 || /^\d+$/.test(String(value)))) {
        this.loadUsers(String(value), resolve);
        return;
      }
      resolve([]);
    },
    loadUsers(roleIds, resolve) {
      $.get(url.getStu('GetUsersByRole'), { roleIds }, (data) => {
        const list = (data || []).map((u) => ({
          value: u.userID,
          label: u.realName || '',
          leaf: true
        }));
        resolve(list);
      }).fail(() => {
        resolve([]);
      });
    },
    onCascaderChange(path) {
      const userID = path && path.length > 0 ? path[path.length - 1] : null;
      this.$emit('input', userID);
      this.$emit('change', userID);
      this.showPopover = false;
      if (userID) {
        this.loadDisplayLabel(userID);
      } else {
        this.displayLabel = '';
      }
    },
    clear() {
      this.$emit('input', null);
      this.$emit('change', null);
      this.displayLabel = '';
      this.showPopover = false;
    }
  }
};
</script>

<style scoped>
.dept-role-teacher-select {
  width: 100%;
}
.dept-role-teacher-suffix {
  display: inline-flex;
  align-items: center;
}
.dept-role-teacher-suffix .el-input__icon {
  cursor: pointer;
}
</style>
